import React, { useState, useRef, useEffect } from "react";
import Calendar from "@fullcalendar/react";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin from "@fullcalendar/interaction";
import momentPlugin from "@fullcalendar/moment";
import { useDispatch, useSelector } from "react-redux";
import { openAlert, closeAlert } from "redux/slices/alertSlice";
import { updateCalendarRange } from "redux/slices/calendarRangeSlice";
import style from "css/calendar.module.css";
import moment from "moment";
import { useTranslation } from "react-i18next";
import "moment/locale/ko";
import { ReactComponent as Camera } from "asset/calendar/camera.svg";
import MeetingRoomInfoModal from "./meetingRoomInfoModal";
import { Spin } from "antd";
/**
 * Version : 1.0
 * 파일명 : ResourceCalendar.js
 * 작성일자 : 2023-04-13
 * 작성자 : 강연승
 * 설명 : 리소스형 풀 캘린더
 * 작성일자 : 2023-04-13
 * 수정자 : 강연승
 * 수정내역 :
 */

function ResourceCalendar(props) {
  //translation
  const { t, i18n } = useTranslation();
  //dispatch
  const dispatch = useDispatch();
  //useSelector
  const meetingTimePayload = useSelector((state) => state.meetingTime);
  //ref
  const calendarRef = useRef();
  //state
  const [calendarApi, setCalendarApi] = useState();
  const [selectRes, setSelectRes] = useState();
  // const [title, setTitle] = useState("");

  // //캘린더 이동 - 이전
  // /* eslint-disable no-useless-escape */
  // const calendarMovePrev = () => {
  //   calendarApi.prev();
  //   // setTitle(calendarApi.view.title);
  //   let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
  //   let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");

  //   const obj = {
  //     VIEW_TYPE: calendarApi.view.type,
  //     ACTIVE_START: start,
  //     ACTIVE_END: end,
  //   };
  //   dispatch(updateCalendarRange(obj));
  // };

  // //캘린더 이동 - 다음
  // /* eslint-disable no-useless-escape */
  // const calendarMoveNext = () => {
  //   calendarApi.next();
  //   // setTitle(calendarApi.view.title);
  //   let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
  //   let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
  //   const obj = {
  //     VIEW_TYPE: calendarApi.view.type,
  //     ACTIVE_START: start,
  //     ACTIVE_END: end,
  //   };
  //   dispatch(updateCalendarRange(obj));
  // };

  //캘린더 이동 - 오늘
  /* eslint-disable no-useless-escape */
  //   const calendarMoveToday = () => {
  //     calendarApi.today();
  //     setTitle(calendarApi.view.title);
  // //moment format 사용
  // let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
  // let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
  //     const obj = {
  //       VIEW_TYPE: calendarApi.view.type,
  //       ACTIVE_START: start,
  //       ACTIVE_END: end,
  //     };
  //     dispatch(updateCalendarRange(obj));
  //   };
  /* eslint-disable no-useless-escape */
  const [calendarVisible, setCalendarVisible] = useState(true);
  const [calendarHeight, setCalendarHeight] = useState(
    props.resource.length * 50 + 70
  );
  useEffect(() => {
    setCalendarVisible(false); // 언마운트
    const timeout = setTimeout(() => {
      setCalendarVisible(true); // 리마운트
      setCalendarHeight(props.resource.length * 50 + 70);
    }, 10); // 너무 길게 안 해도 됨

    return () => clearTimeout(timeout);
  }, [props.resource]);

  useEffect(() => {
    if (calendarRef !== undefined) {
      let calApi = calendarRef.current.getApi();
      setCalendarApi(calApi);
      // setTitle(calApi.view.title);
      let activeStart = moment(calApi.view.activeStart).format("YYYY-MM-DD");
      let activeEnd = moment(calApi.view.activeEnd).format("YYYY-MM-DD");
      // // props.setSchedules([]);
      // // props.getSchedules(activeStart, activeEnd);
      const obj = {
        VIEW_TYPE: calApi.view.type,
        ACTIVE_START: activeStart,
        ACTIVE_END: activeEnd,
      };
      dispatch(updateCalendarRange(obj));
    }
  }, [calendarRef, dispatch]);

  useEffect(() => {
    if (calendarApi !== undefined) {
      let activeStart = moment(calendarApi.view.activeStart).format(
        "YYYY-MM-DD"
      );
      let activeEnd = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
      const obj = {
        VIEW_TYPE: calendarApi.view.type,
        ACTIVE_START: activeStart,
        ACTIVE_END: activeEnd,
      };
      dispatch(updateCalendarRange(obj));
    }
  }, [calendarApi, dispatch]);

  useEffect(() => {
    if (calendarApi !== undefined) {
      if (!meetingTimePayload.VIEW) {
        calendarApi.unselect();
      }
    }
  }, [meetingTimePayload.VIEW, calendarApi]);

  useEffect(() => {
    if (i18n.language === "ko-KR") {
      moment.locale("ko");
    } else if (i18n.language === "en-US") {
      moment.locale("en");
    }
  }, [i18n.language]);

  useEffect(() => {
    if (calendarApi !== undefined) {
      // console.log("view change");
      // console.log(
      //   moment(props.date + " " + meetingTimePayload.START_TIME).format(
      //     "YYYY-MM-DD HH:mm:ss"
      //   ),
      //   moment(props.date + " " + meetingTimePayload.END_TIME).format(
      //     "YYYY-MM-DD HH:mm:ss"
      //   )
      // );
      // console.log("meeting Type : " + meetingTimePayload.TYPE);
      // console.log("meeting View : " + meetingTimePayload.VIEW);
      if (meetingTimePayload.TYPE === "CALENDAR") {
        return;
      }
      if (meetingTimePayload.VIEW) {
        if (props.date !== "") {
          // calendarApi.changeView("resourceTimelineDay", meetingTimePayload.START_DATE);
          if (props.date !== "") {
            let start = props.date + "T" + meetingTimePayload.START_TIME;
            let end = props.date + "T" + meetingTimePayload.END_TIME;
            calendarApi.select({
              start: start,
              end: end,
              allDay: true,
              resourceId: selectRes,
            });
            // if (
            //   moment.utc(calendarApi.view.activeStart).format("YYYY-MM-DD HH:mm:ss") >
            //   moment(meetingTimePayload.START_DATE + " " + meetingTimePayload.START_TIME).format(
            //     "YYYY-MM-DD HH:mm:ss"
            //   ) ||
            //   moment(meetingTimePayload.END_DATE + " " + meetingTimePayload.END_TIME).format(
            //     "YYYY-MM-DD HH:mm:ss"
            //   ) >
            //   moment.utc(calendarApi.view.activeEnd).format("YYYY-MM-DD HH:mm:ss")
            // ) {
            //   console.log("체인지")
            //   // calendarApi.changeView(
            //   //   "resourceTimelineDay",
            //   //   {
            //   //     start: moment(meetingTimePayload.START_TIME).format("YYYY-MM-DD"),
            //   //     end: moment(meetingTimePayload.END_TIME).format("YYYY-MM-DD"),
            //   //   }
            //   // );
            //   // calendarApi.select({
            //   //   start:
            //   //     meetingTimePayload.START_DATE +
            //   //     "T" +
            //   //     meetingTimePayload.START_TIME,
            //   //   end:
            //   //     meetingTimePayload.END_DATE + "T" + meetingTimePayload.END_TIME,
            //   //   resource: {
            //   //     id: meetingTimePayload.RESOURCE
            //   //   }
            //   // });
            // } else {

            //   // calendarApi.select({
            //   //   start:
            //   //     meetingTimePayload.START_DATE +
            //   //     "T" +
            //   //     meetingTimePayload.START_TIME,
            //   //   end:
            //   //     meetingTimePayload.END_DATE + "T" + meetingTimePayload.END_TIME,
            //   //   resource: {
            //   //     ...meetingTimePayload.RESOURCE
            //   //   }
            //   // });
            // }
          }
        }
      }
    }
  }, [calendarApi, meetingTimePayload, props.date, selectRes]);

  useEffect(() => {
    if (!calendarApi) return;

    const calendarEl = calendarApi.el;
    if (!calendarEl) return;

    let isDragging = false;

    const handleMouseDown = (e) => {
      if (e.target.closest(".fc-scroller")) {
        isDragging = true;
      }
    };

    const handleMouseMove = (e) => {
      if (isDragging) {
      }
    };
    const handleMouseUp = (e) => {
      if (!props.alertStatus) {
        props.openPopup();
      }
    };

    calendarEl.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      calendarEl.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [calendarApi, props.alertStatus]);

  // useEffect(() => {

  //   console.log("calendar date : " + props.date);
  //   const calendarEl = calendarRef.current;
  //   const calendar = new Calendar(calendarEl, {
  //     initialDate: props.date,
  //   });

  //   calendar.render();

  //   calendarRef.current = calendar;
  // }, [props.date])

  return (
    <>
      <div className={style.resource_calendar}>
        {calendarVisible && (
          <Calendar
            ref={calendarRef}
            // defaultDate={props.date}
            initialDate={props.date}
            // schedulerLicenseKey="0736858632-fcs-1604369387"
            schedulerLicenseKey="0820383817-fcs-1688451544"
            //   schedulerLicenseKey="CC-Attribution-NonCommercial-NoDerivatives"
            resources={props.resource}
            // resources={props.resource.length > 0 ? props.resource : []}
            plugins={[resourceTimelinePlugin, interactionPlugin, momentPlugin]}
            initialView="resourceTimelineDay"
            resourceAreaHeaderContent={
              t("LABEL.MEETING_ROOM") + " (" + props.resource.length + ")"
            }
            timeZone="Asia/Seoul"
            locale="ko"
            expandRows={true}
            headerToolbar={false}
            scrollTime={moment().subtract(90, "minutes").format("HH:mm:ss")}
            slotDuration="00:10:00"
            slotMinTime="06:00:00"
            slotMaxTime="24:00:00"
            nowIndicator={true}
            dragScroll={true}
            selectOverlap={true} //사용자가 이벤트에 의해 점유되는 기간을 선택할 수 있는지 여부를 결정한다.
            selectable={true} //사용자가 클릭하여 끌어서 여러 일 또는 시간대를 강조 표시하도록 허용.
            selectMirror={true} //드래그한 영역 표시
            unselectAuto={false} //페이지의 다른 곳을 클릭하면 현재 선택 항목이 지워지는지 여부.
            height={calendarHeight} //{props.resource.length * 50 + 70}
            // height={1000}
            eventClick={(e) => {
              props.eventClick(e.event.extendedProps.SCHEDULE_ID);
            }}
            events={props.scheduleList}
            // events={props.scheduleList.length > 0 ? props.scheduleList : []}
            views={{
              resourceTimelineDay: {
                // unselect: function () {
                //   props.resetSelect();
                // },

                select: function (time) {
                  console.log(time.resource);

                  if (time.resource === null) {
                    return;
                  }
                  setSelectRes(time.resource.id);

                  // time.startStr = "2023-07-03T20:00:00";
                  // console.log("time.start : " + time.startStr);
                  // time.endStr = "2023-07-03T20:50:00";
                  // console.log("time.end : " + time.endStr);
                  if (time.end - time.start > 86400000) {
                    const obj = {
                      title: t("MESSAGE.NOTIFICATION"),
                      content: t("MESSAGE.OVER_24HOURS"),
                      submitEventHandler: () => {
                        dispatch(closeAlert());
                      },
                    };
                    dispatch(openAlert(obj));
                    calendarApi.unselect();
                    return;
                  }
                  if (new Date(time.startStr) < new Date()) {
                    const obj = {
                      title: t("MESSAGE.NOTIFICATION"),
                      content: t("MESSAGE.START_TIME_ERROR"),
                      submitEventHandler: () => {
                        dispatch(closeAlert());
                      },
                    };
                    dispatch(openAlert(obj));
                    calendarApi.unselect();
                    return;
                  }
                  props.selectTime(time);
                },
                // eventMinWidth: 10,
                // eventMinHeight: 50,
                // height: 100,
                slotMinWidth: 50,
                eventContent: function (arg) {
                  return (
                    <div className={style.calContent + " cursor"}>
                      {/* <div>{moment(arg.event.startStr).format("a HH:mm")}</div> */}
                      <div className={style.calContent_title}>
                        {arg.event.title}
                      </div>
                    </div>
                  );
                },
                slotLabelFormat: {
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: false,
                },
                resourceAreaWidth: "20%",
                resourceLabelContent: function (arg) {
                  return (
                    <div className={style.resource_label}>
                      <span>{arg.fieldValue}</span>
                      <div className={style.resource_label_icon_area}>
                        {arg.resource.extendedProps.ENDPOINT_TYPE ===
                        "CD1002" ? (
                          <Camera className="cursor" />
                        ) : (
                          <></>
                        )}
                        {/* <Detail className="cursor" /> */}
                        {!arg.resource.extendedProps ? (
                          <></>
                        ) : (
                          <MeetingRoomInfoModal resource={arg.resource} />
                        )}
                      </div>
                    </div>
                  );
                },
              },
            }}
          />
        )}
      </div>
    </>
  );
}

export default ResourceCalendar;
